@file:OptIn(InternalResourceApi::class)

package swetgram.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/swetgram.shared.generated.resources/"

@delegate:ResourceContentHash(-2_103_367_509)
internal val Res.string.chat_refreshing: StringResource by lazy {
      StringResource("string:chat_refreshing", "chat_refreshing", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9733, 51),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6604, 39),
      ))
    }

@delegate:ResourceContentHash(-1_146_558_725)
internal val Res.string.chat_selected_count: StringResource by lazy {
      StringResource("string:chat_selected_count", "chat_selected_count", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9830, 55),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6677, 47),
      ))
    }

@delegate:ResourceContentHash(894_634_742)
internal val Res.string.chat_selection_close: StringResource by lazy {
      StringResource("string:chat_selection_close", "chat_selection_close", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9886, 64),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6725, 48),
      ))
    }

@delegate:ResourceContentHash(-381_991_511)
internal val Res.string.chat_selection_toggle: StringResource by lazy {
      StringResource("string:chat_selection_toggle", "chat_selection_toggle", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 9951, 73),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6774, 49),
      ))
    }

@delegate:ResourceContentHash(-273_023_689)
internal val Res.string.chat_send: StringResource by lazy {
      StringResource("string:chat_send", "chat_send", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 11530, 41),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 7693, 25),
      ))
    }

@delegate:ResourceContentHash(1_455_690_076)
internal val Res.string.chat_send_failed_note: StringResource by lazy {
      StringResource("string:chat_send_failed_note", "chat_send_failed_note", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 10217, 65),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6916, 41),
      ))
    }

@delegate:ResourceContentHash(-1_181_578_394)
internal val Res.string.chat_send_failed_note_retryable: StringResource by lazy {
      StringResource("string:chat_send_failed_note_retryable", "chat_send_failed_note_retryable", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 10025, 191),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6824, 91),
      ))
    }

@delegate:ResourceContentHash(1_683_705_783)
internal val Res.string.chat_send_forbidden: StringResource by lazy {
      StringResource("string:chat_send_forbidden", "chat_send_forbidden", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 10283, 143),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 6958, 95),
      ))
    }

@delegate:ResourceContentHash(1_273_469_782)
internal val Res.string.chat_send_invalid: StringResource by lazy {
      StringResource("string:chat_send_invalid", "chat_send_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 10427, 109),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 7054, 65),
      ))
    }

@delegate:ResourceContentHash(-730_490_607)
internal val Res.string.chat_send_not_found: StringResource by lazy {
      StringResource("string:chat_send_not_found", "chat_send_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 10537, 107),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 7120, 83),
      ))
    }

@delegate:ResourceContentHash(934_164_402)
internal val Res.string.chat_send_offline: StringResource by lazy {
      StringResource("string:chat_send_offline", "chat_send_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 10645, 205),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 7204, 105),
      ))
    }

@delegate:ResourceContentHash(-1_952_939_465)
internal val Res.string.chat_send_rate_limited: StringResource by lazy {
      StringResource("string:chat_send_rate_limited", "chat_send_rate_limited", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 10851, 186),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 7310, 102),
      ))
    }

@delegate:ResourceContentHash(-523_323_555)
internal val Res.string.chat_send_suspended: StringResource by lazy {
      StringResource("string:chat_send_suspended", "chat_send_suspended", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 11038, 159),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 7413, 99),
      ))
    }

@delegate:ResourceContentHash(844_599_411)
internal val Res.string.chat_send_timeout: StringResource by lazy {
      StringResource("string:chat_send_timeout", "chat_send_timeout", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 11198, 197),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 7513, 113),
      ))
    }

@delegate:ResourceContentHash(-9_104_042)
internal val Res.string.chat_send_unknown: StringResource by lazy {
      StringResource("string:chat_send_unknown", "chat_send_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 11396, 133),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 7627, 65),
      ))
    }

@delegate:ResourceContentHash(705_376_090)
internal val Res.string.chat_timeout: StringResource by lazy {
      StringResource("string:chat_timeout", "chat_timeout", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 11572, 100),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 7719, 68),
      ))
    }

@delegate:ResourceContentHash(-1_075_959_290)
internal val Res.string.chat_typing_one: StringResource by lazy {
      StringResource("string:chat_typing_one", "chat_typing_one", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 11673, 55),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 7788, 47),
      ))
    }

@delegate:ResourceContentHash(1_988_935_417)
internal val Res.string.chat_typing_two: StringResource by lazy {
      StringResource("string:chat_typing_two", "chat_typing_two", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 11729, 67),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 7836, 59),
      ))
    }

@delegate:ResourceContentHash(1_556_779_576)
internal val Res.string.chat_unpin_failed: StringResource by lazy {
      StringResource("string:chat_unpin_failed", "chat_unpin_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 11797, 105),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 7896, 65),
      ))
    }

@delegate:ResourceContentHash(1_532_269_493)
internal val Res.string.chat_voice_cancel: StringResource by lazy {
      StringResource("string:chat_voice_cancel", "chat_voice_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 11903, 61),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 7962, 49),
      ))
    }

@delegate:ResourceContentHash(1_719_273_978)
internal val Res.string.chat_voice_delete: StringResource by lazy {
      StringResource("string:chat_voice_delete", "chat_voice_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 11965, 101),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8012, 53),
      ))
    }

@delegate:ResourceContentHash(-319_692_092)
internal val Res.string.chat_voice_failed: StringResource by lazy {
      StringResource("string:chat_voice_failed", "chat_voice_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 12067, 129),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8066, 69),
      ))
    }

@delegate:ResourceContentHash(349_544_375)
internal val Res.string.chat_voice_lock: StringResource by lazy {
      StringResource("string:chat_voice_lock", "chat_voice_lock", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 12197, 63),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8136, 43),
      ))
    }

@delegate:ResourceContentHash(2_030_774_511)
internal val Res.string.chat_voice_message: StringResource by lazy {
      StringResource("string:chat_voice_message", "chat_voice_message", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 12261, 78),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8180, 46),
      ))
    }

@delegate:ResourceContentHash(-496_228_917)
internal val Res.string.chat_voice_pause: StringResource by lazy {
      StringResource("string:chat_voice_pause", "chat_voice_pause", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 12340, 40),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8227, 32),
      ))
    }

@delegate:ResourceContentHash(968_183_222)
internal val Res.string.chat_voice_permission_denied: StringResource by lazy {
      StringResource("string:chat_voice_permission_denied", "chat_voice_permission_denied", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 12381, 180),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8260, 108),
      ))
    }

@delegate:ResourceContentHash(-1_561_311_245)
internal val Res.string.chat_voice_play: StringResource by lazy {
      StringResource("string:chat_voice_play", "chat_voice_play", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 12664, 119),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8431, 47),
      ))
    }

@delegate:ResourceContentHash(1_577_353_708)
internal val Res.string.chat_voice_playback_pause: StringResource by lazy {
      StringResource("string:chat_voice_playback_pause", "chat_voice_playback_pause", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 12562, 101),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8369, 61),
      ))
    }

@delegate:ResourceContentHash(1_996_780_156)
internal val Res.string.chat_voice_preparing: StringResource by lazy {
      StringResource("string:chat_voice_preparing", "chat_voice_preparing", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 12784, 104),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8479, 56),
      ))
    }

@delegate:ResourceContentHash(1_540_627_977)
internal val Res.string.chat_voice_record: StringResource by lazy {
      StringResource("string:chat_voice_record", "chat_voice_record", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 13002, 97),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8597, 57),
      ))
    }

@delegate:ResourceContentHash(921_417_033)
internal val Res.string.chat_voice_recording: StringResource by lazy {
      StringResource("string:chat_voice_recording", "chat_voice_recording", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 12889, 112),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8536, 60),
      ))
    }

@delegate:ResourceContentHash(1_014_990_710)
internal val Res.string.chat_voice_resume: StringResource by lazy {
      StringResource("string:chat_voice_resume", "chat_voice_resume", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 13100, 73),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8655, 33),
      ))
    }

@delegate:ResourceContentHash(1_186_381_312)
internal val Res.string.chat_voice_retry: StringResource by lazy {
      StringResource("string:chat_voice_retry", "chat_voice_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 13174, 92),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8689, 48),
      ))
    }

@delegate:ResourceContentHash(-1_803_790_523)
internal val Res.string.chat_voice_send: StringResource by lazy {
      StringResource("string:chat_voice_send", "chat_voice_send", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 13267, 99),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8738, 47),
      ))
    }

@delegate:ResourceContentHash(868_611_338)
internal val Res.string.chat_voice_slide_cancel: StringResource by lazy {
      StringResource("string:chat_voice_slide_cancel", "chat_voice_slide_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 13367, 83),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8786, 59),
      ))
    }

@delegate:ResourceContentHash(-1_482_805_696)
internal val Res.string.chat_voice_slide_lock: StringResource by lazy {
      StringResource("string:chat_voice_slide_lock", "chat_voice_slide_lock", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 13451, 105),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8846, 53),
      ))
    }

@delegate:ResourceContentHash(1_567_429_692)
internal val Res.string.chat_voice_speed: StringResource by lazy {
      StringResource("string:chat_voice_speed", "chat_voice_speed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 13557, 96),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8900, 52),
      ))
    }

@delegate:ResourceContentHash(2_140_517_288)
internal val Res.string.chat_voice_too_short: StringResource by lazy {
      StringResource("string:chat_voice_too_short", "chat_voice_too_short", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 13654, 124),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 8953, 64),
      ))
    }

@delegate:ResourceContentHash(-195_781_423)
internal val Res.string.chat_voice_uploading: StringResource by lazy {
      StringResource("string:chat_voice_uploading", "chat_voice_uploading", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chat.commonMain.cvr", 13779, 116),
        ResourceItem(setOf(), "${MD}values/strings_chat.commonMain.cvr", 9018, 60),
      ))
    }

@delegate:ResourceContentHash(1_092_101_739)
internal val Res.string.chatlist_action_archive: StringResource by lazy {
      StringResource("string:chatlist_action_archive", "chatlist_action_archive", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 1653, 51),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1085, 43),
      ))
    }

@delegate:ResourceContentHash(-347_039_336)
internal val Res.string.chatlist_action_cancel: StringResource by lazy {
      StringResource("string:chatlist_action_cancel", "chatlist_action_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 1705, 46),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1129, 38),
      ))
    }

@delegate:ResourceContentHash(2_122_233_061)
internal val Res.string.chatlist_action_delete: StringResource by lazy {
      StringResource("string:chatlist_action_delete", "chatlist_action_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 1816, 50),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1220, 38),
      ))
    }

@delegate:ResourceContentHash(1_489_595_098)
internal val Res.string.chatlist_action_delete_chat: StringResource by lazy {
      StringResource("string:chatlist_action_delete_chat", "chatlist_action_delete_chat", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 1752, 63),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1168, 51),
      ))
    }

@delegate:ResourceContentHash(-1_118_623_354)
internal val Res.string.chatlist_action_mute: StringResource by lazy {
      StringResource("string:chatlist_action_mute", "chatlist_action_mute", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 1867, 88),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1259, 40),
      ))
    }

@delegate:ResourceContentHash(2_049_333_162)
internal val Res.string.chatlist_action_pin: StringResource by lazy {
      StringResource("string:chatlist_action_pin", "chatlist_action_pin", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 1956, 71),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1300, 43),
      ))
    }

@delegate:ResourceContentHash(-2_117_135_603)
internal val Res.string.chatlist_action_restore: StringResource by lazy {
      StringResource("string:chatlist_action_restore", "chatlist_action_restore", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 2028, 75),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1344, 59),
      ))
    }

@delegate:ResourceContentHash(-1_873_929_632)
internal val Res.string.chatlist_action_unmute: StringResource by lazy {
      StringResource("string:chatlist_action_unmute", "chatlist_action_unmute", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 2104, 82),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1404, 38),
      ))
    }

@delegate:ResourceContentHash(523_974_052)
internal val Res.string.chatlist_action_unpin: StringResource by lazy {
      StringResource("string:chatlist_action_unpin", "chatlist_action_unpin", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 2187, 53),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1443, 37),
      ))
    }

@delegate:ResourceContentHash(-709_289_498)
internal val Res.string.chatlist_archive_empty_body: StringResource by lazy {
      StringResource("string:chatlist_archive_empty_body", "chatlist_archive_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 2241, 175),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1481, 111),
      ))
    }

@delegate:ResourceContentHash(-180_713_762)
internal val Res.string.chatlist_archive_empty_title: StringResource by lazy {
      StringResource("string:chatlist_archive_empty_title", "chatlist_archive_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 2417, 72),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1593, 60),
      ))
    }

@delegate:ResourceContentHash(1_882_630_519)
internal val Res.string.chatlist_archived_title: StringResource by lazy {
      StringResource("string:chatlist_archived_title", "chatlist_archived_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 2490, 47),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1654, 43),
      ))
    }

@delegate:ResourceContentHash(-1_342_253_117)
internal val Res.string.chatlist_delete_dialog_body: StringResource by lazy {
      StringResource("string:chatlist_delete_dialog_body", "chatlist_delete_dialog_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 2538, 167),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1698, 131),
      ))
    }

@delegate:ResourceContentHash(-1_781_521_232)
internal val Res.string.chatlist_delete_dialog_title: StringResource by lazy {
      StringResource("string:chatlist_delete_dialog_title", "chatlist_delete_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 2706, 80),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1830, 60),
      ))
    }

@delegate:ResourceContentHash(-1_095_227_697)
internal val Res.string.chatlist_empty_body: StringResource by lazy {
      StringResource("string:chatlist_empty_body", "chatlist_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 2787, 67),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1891, 55),
      ))
    }

@delegate:ResourceContentHash(1_388_309_564)
internal val Res.string.chatlist_empty_title: StringResource by lazy {
      StringResource("string:chatlist_empty_title", "chatlist_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 2855, 64),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1947, 48),
      ))
    }

@delegate:ResourceContentHash(-1_857_490_099)
internal val Res.string.chatlist_error_archive_failed: StringResource by lazy {
      StringResource("string:chatlist_error_archive_failed", "chatlist_error_archive_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 2920, 109),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 1996, 77),
      ))
    }

@delegate:ResourceContentHash(-1_252_025_850)
internal val Res.string.chatlist_error_delete_failed: StringResource by lazy {
      StringResource("string:chatlist_error_delete_failed", "chatlist_error_delete_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 3030, 92),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 2074, 72),
      ))
    }

@delegate:ResourceContentHash(-987_983_477)
internal val Res.string.chatlist_error_mute_failed: StringResource by lazy {
      StringResource("string:chatlist_error_mute_failed", "chatlist_error_mute_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 3123, 118),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 2147, 70),
      ))
    }

@delegate:ResourceContentHash(359_156_764)
internal val Res.string.chatlist_error_offline: StringResource by lazy {
      StringResource("string:chatlist_error_offline", "chatlist_error_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 3242, 66),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 2218, 50),
      ))
    }

@delegate:ResourceContentHash(967_869_619)
internal val Res.string.chatlist_error_open_failed: StringResource by lazy {
      StringResource("string:chatlist_error_open_failed", "chatlist_error_open_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 3309, 90),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 2269, 70),
      ))
    }

@delegate:ResourceContentHash(743_965_913)
internal val Res.string.chatlist_error_open_forbidden: StringResource by lazy {
      StringResource("string:chatlist_error_open_forbidden", "chatlist_error_open_forbidden", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 3400, 125),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 2340, 93),
      ))
    }

@delegate:ResourceContentHash(-526_494_148)
internal val Res.string.chatlist_error_pin_failed: StringResource by lazy {
      StringResource("string:chatlist_error_pin_failed", "chatlist_error_pin_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 3526, 97),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 2434, 65),
      ))
    }

@delegate:ResourceContentHash(-719_842_872)
internal val Res.string.chatlist_error_refresh_failed: StringResource by lazy {
      StringResource("string:chatlist_error_refresh_failed", "chatlist_error_refresh_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 3624, 105),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 2500, 61),
      ))
    }

@delegate:ResourceContentHash(1_841_209_773)
internal val Res.string.chatlist_error_restore_failed: StringResource by lazy {
      StringResource("string:chatlist_error_restore_failed", "chatlist_error_restore_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 3730, 117),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 2562, 77),
      ))
    }

@delegate:ResourceContentHash(371_953_433)
internal val Res.string.chatlist_error_search_failed: StringResource by lazy {
      StringResource("string:chatlist_error_search_failed", "chatlist_error_search_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 3848, 96),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 2640, 72),
      ))
    }

@delegate:ResourceContentHash(1_246_403_726)
internal val Res.string.chatlist_error_timeout: StringResource by lazy {
      StringResource("string:chatlist_error_timeout", "chatlist_error_timeout", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 3945, 94),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 2713, 78),
      ))
    }

@delegate:ResourceContentHash(35_059_233)
internal val Res.string.chatlist_error_unmute_failed: StringResource by lazy {
      StringResource("string:chatlist_error_unmute_failed", "chatlist_error_unmute_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 4040, 116),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 2792, 72),
      ))
    }

@delegate:ResourceContentHash(1_813_541_828)
internal val Res.string.chatlist_error_unpin_failed: StringResource by lazy {
      StringResource("string:chatlist_error_unpin_failed", "chatlist_error_unpin_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 4157, 99),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 2865, 71),
      ))
    }

@delegate:ResourceContentHash(1_224_554_930)
internal val Res.string.chatlist_error_upgrade_required: StringResource by lazy {
      StringResource("string:chatlist_error_upgrade_required", "chatlist_error_upgrade_required", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 4257, 103),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 2937, 71),
      ))
    }

@delegate:ResourceContentHash(683_004_075)
internal val Res.string.chatlist_mute_dialog_body: StringResource by lazy {
      StringResource("string:chatlist_mute_dialog_body", "chatlist_mute_dialog_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 4361, 201),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3009, 133),
      ))
    }

@delegate:ResourceContentHash(256_620_217)
internal val Res.string.chatlist_mute_dialog_title: StringResource by lazy {
      StringResource("string:chatlist_mute_dialog_title", "chatlist_mute_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 4563, 98),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3143, 46),
      ))
    }

@delegate:ResourceContentHash(-1_808_933_758)
internal val Res.string.chatlist_new_chat: StringResource by lazy {
      StringResource("string:chatlist_new_chat", "chatlist_new_chat", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 5050, 49),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3490, 37),
      ))
    }

@delegate:ResourceContentHash(-552_903_236)
internal val Res.string.chatlist_new_chat_description: StringResource by lazy {
      StringResource("string:chatlist_new_chat_description", "chatlist_new_chat_description", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 4662, 77),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3190, 57),
      ))
    }

@delegate:ResourceContentHash(1_669_887_827)
internal val Res.string.chatlist_new_chat_prompt_body: StringResource by lazy {
      StringResource("string:chatlist_new_chat_prompt_body", "chatlist_new_chat_prompt_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 4740, 125),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3248, 101),
      ))
    }

@delegate:ResourceContentHash(490_941_846)
internal val Res.string.chatlist_new_chat_prompt_title: StringResource by lazy {
      StringResource("string:chatlist_new_chat_prompt_title", "chatlist_new_chat_prompt_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 4866, 78),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3350, 58),
      ))
    }

@delegate:ResourceContentHash(-1_328_538_322)
internal val Res.string.chatlist_new_chat_search_placeholder: StringResource by lazy {
      StringResource("string:chatlist_new_chat_search_placeholder", "chatlist_new_chat_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 4945, 104),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3409, 80),
      ))
    }

@delegate:ResourceContentHash(1_595_300_908)
internal val Res.string.chatlist_preview_by_deleted: StringResource by lazy {
      StringResource("string:chatlist_preview_by_deleted", "chatlist_preview_by_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 5100, 87),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3528, 63),
      ))
    }

@delegate:ResourceContentHash(1_582_848_165)
internal val Res.string.chatlist_preview_by_empty: StringResource by lazy {
      StringResource("string:chatlist_preview_by_empty", "chatlist_preview_by_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 5188, 89),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3592, 61),
      ))
    }

@delegate:ResourceContentHash(1_401_843_197)
internal val Res.string.chatlist_preview_by_photo: StringResource by lazy {
      StringResource("string:chatlist_preview_by_photo", "chatlist_preview_by_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 5278, 53),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3654, 57),
      ))
    }

@delegate:ResourceContentHash(561_399_776)
internal val Res.string.chatlist_preview_by_text: StringResource by lazy {
      StringResource("string:chatlist_preview_by_text", "chatlist_preview_by_text", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 5332, 48),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3712, 48),
      ))
    }

@delegate:ResourceContentHash(90_533_261)
internal val Res.string.chatlist_preview_by_voice: StringResource by lazy {
      StringResource("string:chatlist_preview_by_voice", "chatlist_preview_by_voice", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 5381, 93),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3761, 61),
      ))
    }

@delegate:ResourceContentHash(1_431_418_906)
internal val Res.string.chatlist_preview_deleted: StringResource by lazy {
      StringResource("string:chatlist_preview_deleted", "chatlist_preview_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 5475, 76),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3823, 52),
      ))
    }

@delegate:ResourceContentHash(-1_990_220_269)
internal val Res.string.chatlist_preview_empty: StringResource by lazy {
      StringResource("string:chatlist_preview_empty", "chatlist_preview_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 5552, 78),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3876, 50),
      ))
    }

@delegate:ResourceContentHash(636_950_123)
internal val Res.string.chatlist_preview_photo: StringResource by lazy {
      StringResource("string:chatlist_preview_photo", "chatlist_preview_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 5631, 42),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3927, 46),
      ))
    }

@delegate:ResourceContentHash(49_296_280)
internal val Res.string.chatlist_preview_speaker_self: StringResource by lazy {
      StringResource("string:chatlist_preview_speaker_self", "chatlist_preview_speaker_self", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 5674, 41),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 3974, 41),
      ))
    }

@delegate:ResourceContentHash(2_030_774_511)
internal val Res.string.chatlist_preview_voice: StringResource by lazy {
      StringResource("string:chatlist_preview_voice", "chatlist_preview_voice", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 5716, 82),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4016, 50),
      ))
    }

@delegate:ResourceContentHash(670_852_924)
internal val Res.string.chatlist_row_long_press_label: StringResource by lazy {
      StringResource("string:chatlist_row_long_press_label", "chatlist_row_long_press_label", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 5799, 77),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4067, 53),
      ))
    }

@delegate:ResourceContentHash(-895_467_387)
internal val Res.string.chatlist_row_muted_description: StringResource by lazy {
      StringResource("string:chatlist_row_muted_description", "chatlist_row_muted_description", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 5877, 94),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4121, 46),
      ))
    }

@delegate:ResourceContentHash(1_815_164_780)
internal val Res.string.chatlist_row_open_profile_label: StringResource by lazy {
      StringResource("string:chatlist_row_open_profile_label", "chatlist_row_open_profile_label", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 5972, 79),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4168, 55),
      ))
    }

@delegate:ResourceContentHash(-14_512_913)
internal val Res.string.chatlist_search_empty_body: StringResource by lazy {
      StringResource("string:chatlist_search_empty_body", "chatlist_search_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6052, 146),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4224, 74),
      ))
    }

@delegate:ResourceContentHash(1_011_112_067)
internal val Res.string.chatlist_search_empty_title: StringResource by lazy {
      StringResource("string:chatlist_search_empty_title", "chatlist_search_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6199, 79),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4299, 59),
      ))
    }

@delegate:ResourceContentHash(356_403_819)
internal val Res.string.chatlist_search_placeholder: StringResource by lazy {
      StringResource("string:chatlist_search_placeholder", "chatlist_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6279, 51),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4359, 43),
      ))
    }

@delegate:ResourceContentHash(1_119_431_546)
internal val Res.string.chatlist_section_all_chats: StringResource by lazy {
      StringResource("string:chatlist_section_all_chats", "chatlist_section_all_chats", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6331, 54),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4403, 46),
      ))
    }

@delegate:ResourceContentHash(-454_636_475)
internal val Res.string.chatlist_section_chats: StringResource by lazy {
      StringResource("string:chatlist_section_chats", "chatlist_section_chats", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6386, 42),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4450, 38),
      ))
    }

@delegate:ResourceContentHash(960_010_859)
internal val Res.string.chatlist_section_people: StringResource by lazy {
      StringResource("string:chatlist_section_people", "chatlist_section_people", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6429, 43),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4489, 39),
      ))
    }

@delegate:ResourceContentHash(738_094_806)
internal val Res.string.chatlist_section_pinned: StringResource by lazy {
      StringResource("string:chatlist_section_pinned", "chatlist_section_pinned", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6473, 63),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4529, 39),
      ))
    }

@delegate:ResourceContentHash(-454_636_475)
internal val Res.string.chatlist_tab_chats: StringResource by lazy {
      StringResource("string:chatlist_tab_chats", "chatlist_tab_chats", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6537, 38),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4569, 34),
      ))
    }

@delegate:ResourceContentHash(193_783_008)
internal val Res.string.chatlist_tab_discover: StringResource by lazy {
      StringResource("string:chatlist_tab_discover", "chatlist_tab_discover", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6576, 41),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4604, 41),
      ))
    }

@delegate:ResourceContentHash(2_132_735_283)
internal val Res.string.chatlist_tab_groups: StringResource by lazy {
      StringResource("string:chatlist_tab_groups", "chatlist_tab_groups", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6618, 43),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4646, 35),
      ))
    }

@delegate:ResourceContentHash(-39_395_200)
internal val Res.string.chatlist_tab_picso: StringResource by lazy {
      StringResource("string:chatlist_tab_picso", "chatlist_tab_picso", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6662, 34),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4682, 34),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("chat_refreshing", Res.string.chat_refreshing)
  map.put("chat_selected_count", Res.string.chat_selected_count)
  map.put("chat_selection_close", Res.string.chat_selection_close)
  map.put("chat_selection_toggle", Res.string.chat_selection_toggle)
  map.put("chat_send", Res.string.chat_send)
  map.put("chat_send_failed_note", Res.string.chat_send_failed_note)
  map.put("chat_send_failed_note_retryable", Res.string.chat_send_failed_note_retryable)
  map.put("chat_send_forbidden", Res.string.chat_send_forbidden)
  map.put("chat_send_invalid", Res.string.chat_send_invalid)
  map.put("chat_send_not_found", Res.string.chat_send_not_found)
  map.put("chat_send_offline", Res.string.chat_send_offline)
  map.put("chat_send_rate_limited", Res.string.chat_send_rate_limited)
  map.put("chat_send_suspended", Res.string.chat_send_suspended)
  map.put("chat_send_timeout", Res.string.chat_send_timeout)
  map.put("chat_send_unknown", Res.string.chat_send_unknown)
  map.put("chat_timeout", Res.string.chat_timeout)
  map.put("chat_typing_one", Res.string.chat_typing_one)
  map.put("chat_typing_two", Res.string.chat_typing_two)
  map.put("chat_unpin_failed", Res.string.chat_unpin_failed)
  map.put("chat_voice_cancel", Res.string.chat_voice_cancel)
  map.put("chat_voice_delete", Res.string.chat_voice_delete)
  map.put("chat_voice_failed", Res.string.chat_voice_failed)
  map.put("chat_voice_lock", Res.string.chat_voice_lock)
  map.put("chat_voice_message", Res.string.chat_voice_message)
  map.put("chat_voice_pause", Res.string.chat_voice_pause)
  map.put("chat_voice_permission_denied", Res.string.chat_voice_permission_denied)
  map.put("chat_voice_play", Res.string.chat_voice_play)
  map.put("chat_voice_playback_pause", Res.string.chat_voice_playback_pause)
  map.put("chat_voice_preparing", Res.string.chat_voice_preparing)
  map.put("chat_voice_record", Res.string.chat_voice_record)
  map.put("chat_voice_recording", Res.string.chat_voice_recording)
  map.put("chat_voice_resume", Res.string.chat_voice_resume)
  map.put("chat_voice_retry", Res.string.chat_voice_retry)
  map.put("chat_voice_send", Res.string.chat_voice_send)
  map.put("chat_voice_slide_cancel", Res.string.chat_voice_slide_cancel)
  map.put("chat_voice_slide_lock", Res.string.chat_voice_slide_lock)
  map.put("chat_voice_speed", Res.string.chat_voice_speed)
  map.put("chat_voice_too_short", Res.string.chat_voice_too_short)
  map.put("chat_voice_uploading", Res.string.chat_voice_uploading)
  map.put("chatlist_action_archive", Res.string.chatlist_action_archive)
  map.put("chatlist_action_cancel", Res.string.chatlist_action_cancel)
  map.put("chatlist_action_delete", Res.string.chatlist_action_delete)
  map.put("chatlist_action_delete_chat", Res.string.chatlist_action_delete_chat)
  map.put("chatlist_action_mute", Res.string.chatlist_action_mute)
  map.put("chatlist_action_pin", Res.string.chatlist_action_pin)
  map.put("chatlist_action_restore", Res.string.chatlist_action_restore)
  map.put("chatlist_action_unmute", Res.string.chatlist_action_unmute)
  map.put("chatlist_action_unpin", Res.string.chatlist_action_unpin)
  map.put("chatlist_archive_empty_body", Res.string.chatlist_archive_empty_body)
  map.put("chatlist_archive_empty_title", Res.string.chatlist_archive_empty_title)
  map.put("chatlist_archived_title", Res.string.chatlist_archived_title)
  map.put("chatlist_delete_dialog_body", Res.string.chatlist_delete_dialog_body)
  map.put("chatlist_delete_dialog_title", Res.string.chatlist_delete_dialog_title)
  map.put("chatlist_empty_body", Res.string.chatlist_empty_body)
  map.put("chatlist_empty_title", Res.string.chatlist_empty_title)
  map.put("chatlist_error_archive_failed", Res.string.chatlist_error_archive_failed)
  map.put("chatlist_error_delete_failed", Res.string.chatlist_error_delete_failed)
  map.put("chatlist_error_mute_failed", Res.string.chatlist_error_mute_failed)
  map.put("chatlist_error_offline", Res.string.chatlist_error_offline)
  map.put("chatlist_error_open_failed", Res.string.chatlist_error_open_failed)
  map.put("chatlist_error_open_forbidden", Res.string.chatlist_error_open_forbidden)
  map.put("chatlist_error_pin_failed", Res.string.chatlist_error_pin_failed)
  map.put("chatlist_error_refresh_failed", Res.string.chatlist_error_refresh_failed)
  map.put("chatlist_error_restore_failed", Res.string.chatlist_error_restore_failed)
  map.put("chatlist_error_search_failed", Res.string.chatlist_error_search_failed)
  map.put("chatlist_error_timeout", Res.string.chatlist_error_timeout)
  map.put("chatlist_error_unmute_failed", Res.string.chatlist_error_unmute_failed)
  map.put("chatlist_error_unpin_failed", Res.string.chatlist_error_unpin_failed)
  map.put("chatlist_error_upgrade_required", Res.string.chatlist_error_upgrade_required)
  map.put("chatlist_mute_dialog_body", Res.string.chatlist_mute_dialog_body)
  map.put("chatlist_mute_dialog_title", Res.string.chatlist_mute_dialog_title)
  map.put("chatlist_new_chat", Res.string.chatlist_new_chat)
  map.put("chatlist_new_chat_description", Res.string.chatlist_new_chat_description)
  map.put("chatlist_new_chat_prompt_body", Res.string.chatlist_new_chat_prompt_body)
  map.put("chatlist_new_chat_prompt_title", Res.string.chatlist_new_chat_prompt_title)
  map.put("chatlist_new_chat_search_placeholder", Res.string.chatlist_new_chat_search_placeholder)
  map.put("chatlist_preview_by_deleted", Res.string.chatlist_preview_by_deleted)
  map.put("chatlist_preview_by_empty", Res.string.chatlist_preview_by_empty)
  map.put("chatlist_preview_by_photo", Res.string.chatlist_preview_by_photo)
  map.put("chatlist_preview_by_text", Res.string.chatlist_preview_by_text)
  map.put("chatlist_preview_by_voice", Res.string.chatlist_preview_by_voice)
  map.put("chatlist_preview_deleted", Res.string.chatlist_preview_deleted)
  map.put("chatlist_preview_empty", Res.string.chatlist_preview_empty)
  map.put("chatlist_preview_photo", Res.string.chatlist_preview_photo)
  map.put("chatlist_preview_speaker_self", Res.string.chatlist_preview_speaker_self)
  map.put("chatlist_preview_voice", Res.string.chatlist_preview_voice)
  map.put("chatlist_row_long_press_label", Res.string.chatlist_row_long_press_label)
  map.put("chatlist_row_muted_description", Res.string.chatlist_row_muted_description)
  map.put("chatlist_row_open_profile_label", Res.string.chatlist_row_open_profile_label)
  map.put("chatlist_search_empty_body", Res.string.chatlist_search_empty_body)
  map.put("chatlist_search_empty_title", Res.string.chatlist_search_empty_title)
  map.put("chatlist_search_placeholder", Res.string.chatlist_search_placeholder)
  map.put("chatlist_section_all_chats", Res.string.chatlist_section_all_chats)
  map.put("chatlist_section_chats", Res.string.chatlist_section_chats)
  map.put("chatlist_section_people", Res.string.chatlist_section_people)
  map.put("chatlist_section_pinned", Res.string.chatlist_section_pinned)
  map.put("chatlist_tab_chats", Res.string.chatlist_tab_chats)
  map.put("chatlist_tab_discover", Res.string.chatlist_tab_discover)
  map.put("chatlist_tab_groups", Res.string.chatlist_tab_groups)
  map.put("chatlist_tab_picso", Res.string.chatlist_tab_picso)
}
